export const DOMAIN_KEYS = ["people", "living", "food", "mobility", "consumer", "happiness"] as const;

const FR_TO_KEY: Record<string, string> = {
  "personnes": "people",
  "espaces": "living",
  "alimentation": "food",
  "mobilité": "mobility",
  "produits": "consumer",
  "bonheur": "happiness",
};

export function getDomainKey(domainName?: string): string {
  const firstWord = (domainName ?? "").split(" ")[0].toLowerCase().replace(",", "");

  return FR_TO_KEY[firstWord] ?? firstWord;
}
